import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Button, Divider, Flex, Form, Modal, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import FormContentWrapper from "./FormContentWrapper";
import { convertFormToQuery } from "./helper/convertFormToQuery";
import { FormValues } from "./types/FormValues";

type ParseQueryFormProps = {
  value?: FormValues;
  onChange?: (value: FormValues) => void;
};

const ParseQueryForm = (props: ParseQueryFormProps) => {
  const t = useTranslation();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [queryCount, setQueryCount] = useState(-1); // -1 = invalid
  const [form] = Form.useForm();

  useEffect(() => {
    if (!props.value || !props.value.className) return;
    const query = convertFormToQuery(props.value);

    try {
      query.count().then((result) => setQueryCount(result));
    } catch (e) {
      console.error(e);
      setQueryCount(-1);
    }
  }, [props.value]);

  function handleOnChange(values: FormValues) {
    props.onChange(values);
    setEditModalOpen(false);
  }

  return (
    <>
      <Flex gap="8px" align="center">
        <Button onClick={() => setEditModalOpen(true)}>
          {t(
            "openware:classes.OD3_Monitoring_ParseTableSensor.edit.query.button.label"
          )}
        </Button>
        <Tooltip
          title={t(
            "openware:parse.form.query." +
              (queryCount >= 0 ? "valid" : "invalid"),
            { count: queryCount >= 0 ? queryCount : 0 }
          )}
        >
          <Icon
            icon={queryCount >= 0 ? "fa:check" : "fa:exclamation"}
            color={queryCount >= 0 ? "green" : "red"}
          />
        </Tooltip>
      </Flex>
      <Modal
        width="80%"
        open={editModalOpen}
        onCancel={() => setEditModalOpen(false)}
        // onClose={() => setEditModalOpen(false)}
        footer={null}
      >
        <Form
          form={form}
          onFinish={handleOnChange}
          layout="vertical"
          initialValues={props.value}
        >
          <FormContentWrapper />
          <Divider />
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button htmlType="submit">
              {t("openware:parse.form.submit.label")}
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default ParseQueryForm;
export type { ParseQueryFormProps };
